var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergyStarScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.61 30.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fc7f11;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_1828884",
    className: "cls-1",
    d: "M28.29,12.31c-.16-.51-.62-.87-1.15-.92l-7.25-.66-2.86-6.71c-.29-.68-1.07-.99-1.75-.7-.32.14-.57.39-.7.7l-2.87,6.71-7.25.66c-.73.07-1.27.72-1.21,1.45.03.34.19.65.45.88l5.48,4.8-1.62,7.12c-.16.72.28,1.43,1,1.6.33.08.69.02.98-.16l6.25-3.74,6.25,3.74c.63.38,1.45.17,1.83-.46.18-.29.23-.65.16-.98l-1.61-7.12,5.48-4.8c.4-.35.56-.91.39-1.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyStarScore);
export default __webpack_public_path__ + "static/media/Energy Star Score.4308d5f9e227421e5897c91203abb7c9.svg";
export { ForwardRef as ReactComponent };